export const TextCell = (props) => (
                  <div
                    className={`bg-no-repeat bg-gradient-to-r flex ml-3 font-bold text-slate-800 basis-2/12 border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left items-center`} 
                  >
                    <div className="flex flex-1">
                      {props.value}
                    </div>
                  </div>
  )
